import React from "react";

const Track = () => {
  return (
    <>
      <div className="col-md-9">
        <div className="grid-layout wrapper-shop">
          <div className="tf-login-content">
            <h6>Track Order</h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default Track;
